import ImageryPhoto1 from "../../img/DigitalAssets/ImageryPhoto1.webp";
import ImageryPhoto2 from "../../img/DigitalAssets/ImageryPhoto2.webp";
import ImageryPhoto3 from "../../img/DigitalAssets/ImageryPhoto3.webp";
import ImageryPeople1 from "../../img/DigitalAssets/ImageryPeople1.webp";
import ImageryPeople2 from "../../img/DigitalAssets/ImageryPeople2.webp";
import ImageryPeople3 from "../../img/DigitalAssets/ImageryPeople3.webp";
import ImageryPastel1 from "../../img/DigitalAssets/ImageryPastel1.webp";
import ImageryPastel2 from "../../img/DigitalAssets/ImageryPastel2.webp";
import ImageryPastel3 from "../../img/DigitalAssets/ImageryPastel3.webp";
import ImageryPastel4 from "../../img/DigitalAssets/ImageryPastel4.webp";
import ImageryWhite1 from "../../img/DigitalAssets/ImageryWhite1.webp";
import ImageryWhite2 from "../../img/DigitalAssets/ImageryWhite2.webp";
import { VerticalAlignBottomOutlined } from "@ant-design/icons";
import { Button } from "antd";

export interface DigitalAssetsImageryProps {
  downloadZip: (name: string) => void;
}


export function DigitalAssetsImagery({downloadZip}: DigitalAssetsImageryProps) {
  return (
    <div className={"scroll-area imagery"}>
      <div className={"assets-banner mobile-only"}>
        <div>
          <p>Brand Elements</p>
          <div className={"border-el"}/>
          <h1>Imagery</h1>
        </div>
      </div>
      <section className={"one"}>
        <h2>Realistic products with photo background</h2>
        <p>Our template designs shown in realistic restaurant settings</p>
        <div className={"images"}>
          <img src={ImageryPhoto1} alt="Realistic 1" style={{width: '100%'}}/>
          <img src={ImageryPhoto2} alt="Realistic 2" style={{width: '48%'}}/>
          <img src={ImageryPhoto3} alt="Realistic 3" style={{width: '48%'}}/>
        </div>
        <Button className={"mobile-only download-btn"} onClick={() => downloadZip('Images')}><VerticalAlignBottomOutlined/>Download Images</Button>
      </section>
      <section className={"two"}>
        <h2>Photos featuring people mixed with realistic products</h2>
        <p>Our template designs shown on realistic products mixed with photos of people in restaurant or real life settings</p>
        <div className={"images"}>
          <img src={ImageryPeople1} alt="People 1" style={{width: '81%'}}/>
          <img src={ImageryPeople2} alt="People 2" style={{width: '43%'}}/>
          <img src={ImageryPeople3} alt="People 3" style={{width: '46%'}}/>
        </div>
      </section>      
      <section className={"three"}>
        <h2>Realistic product with solid pastel color background</h2>
        <p>Realistic products shown on pastel color backgrounds as outlined in the <a href="/content/assets/colors">Colors</a> section</p>
        <div className={"images"}>
          <img src={ImageryPastel1} alt="Pastel 1" style={{width: '48%'}}/>
          <img src={ImageryPastel2} alt="Pastel 2" style={{width: '48%'}}/>
          <img src={ImageryPastel3} alt="Pastel 3" style={{width: '48%'}}/>
          <img src={ImageryPastel4} alt="Pastel 3" style={{width: '48%'}}/>
        </div>
      </section>
      <section className={"four"}>
        <h2>Realistic products isolated on white background</h2>
        <p>Realistic products shown on a white background</p>
        <div className={"images"}>
          <img src={ImageryWhite1} alt="White 1" style={{width: '62%'}}/>
          <img src={ImageryWhite2} alt="White 2" style={{width: '76%'}}/>
        </div>
      </section>
    </div>
  )
}